import { ProjectList } from './project/list/projectlist';
import { ProjectInfo } from './project/detail/projectinfo';
import { ProjectFundingList } from './profunding/list/list';
import { ProjectFundingDetail } from './profunding/detail/detail';
import { ThesisList } from './thesis/list/list';
import { ThesisDetail } from './thesis/detail/detail';
import { ProductionList } from './production/list/list';
import { ProductionDetail } from './production/detail/detail';
import { CopyrightList } from './copyright/list/list';
import { CopyrightDetail } from './copyright/detail/detail';
import { ReportList } from './report/list/list';
import { ReportDetail } from './report/detail/detail';
import { PrizeList } from './prize/list/list';
import { PrizeDetail } from './prize/detail/detail';
import { IdentificationList } from './identification/list/list';
import { IdentificationDetail } from './identification/detail/detail';
import { PatentList } from './patent/list/list';
import { PatentDetail } from './patent/detail/detail';

export const RESEARCH_INDEX = [
  ProjectList,
  ProjectInfo,
  ProjectFundingList,
  ProjectFundingDetail,
  ThesisList,
  ThesisDetail,
  ProductionList,
  ProductionDetail,
  CopyrightList,
  CopyrightDetail,
  ReportList,
  ReportDetail,
  PrizeList,
  PrizeDetail,
  IdentificationList,
  IdentificationDetail,
  PatentList,
  PatentDetail
];



// WEBPACK FOOTER //
// ./src/pages/application/research/index.ts